import { render, staticRenderFns } from "./Validaciones.vue?vue&type=template&id=247cc4aa&scoped=true"
import script from "./Validaciones.vue?vue&type=script&lang=js"
export * from "./Validaciones.vue?vue&type=script&lang=js"
import style0 from "./Validaciones.vue?vue&type=style&index=0&id=247cc4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cc4aa",
  null
  
)

export default component.exports